import { useContext } from 'react';
import { BlackcartContext } from './BlackCartContext';
import { IBlackcartData } from '../types';

export const useBlackcart = (): IBlackcartData => {
  const context = useContext(BlackcartContext);

  if (!context?.shopDomain) {
    throw new Error('useStore must be used within a BlackcartProvider');
  }

  return {
    baseBlackcart: context.baseBlackcart,
    setCart: context.setCart,
    setCurrency: context.setCurrency,
    isInitializing: context.isInitializing,
    goToBlackcartCheckout: context.goToBlackcartCheckout,
    isTBYBQualifiedCart: context.isTBYBQualifiedCart,
    isTBYBItem: context.isTBYBItem,
    cartViolations: context.cartViolations,
    payTodayTotal: context.payTodayTotal,
    deposit: context.deposit,
    showBlackcartModal: context.showBlackcartModal,
    bcCart: context.bcCart
  };
};
